import { useState, useEffect } from "react";

import axiosInstance from "../../../api/axios";
import DataTable from "../../table/DataTable";

import "../../../clients.css";

const columns = [
  { id: "id", label: "#" },
  { id: "name", label: "Értesítés típus" },
  { id: "createdAt", label: "Létrehozás dátuma" },
  { id: "action", label: "Művelet" },
];

const NotificationTypes = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axiosInstance
      .get("/api-admin/notifications/types")
      .then((response) => {
        setData(response.data.result);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <DataTable
      dataList={data}
      createButtonLink={"/new-notification-type"}
      createButtonText={"Új értesités típus létrehozása"}
      editable={true}
      title={"Értesítés típus lista"}
      columns={columns}
      operationLink={"edit-notification-type"}
      loading={loading}
    />
  );
};

export default NotificationTypes;
